import {
    attrsToString,
    appendToContent,
    open,
    close,
    closeAll
} from './helpers';
import {
    blocks,
    assets,
    twitch,
    themes,
    settings
} from '../leftPanels';

/**
 * Build panels based on config
 * 
 * @param {Object} editor
 * @param {String} pfx Style prefix
 * @param {Array} config
 * @param {Object} filters
 * 
 * @returns HTMLElement
 */
export default (editor, pfx, config, filters) => {
    const $ = editor.$;
    let leftPanelBtns = $('<div></div>');
    let leftPanelContainers = $('<div></div>');

    config.forEach((model, idx) => {
        const {
            attributes,
            label,
            icon,
            color,
            content
        } = model;
        const {
            type,
            help,
            html
        } = content;
        const attr = attrsToString(attributes);
        leftPanelBtns.append($(`<div class="${pfx}pn-left-btn ${pfx}${color}-btn" data-index=${idx}>
            <div ${attr} data-index=${idx}>${icon} 
                <span class="label-text">${label}</span>
            </div>
        </div>`));
        const leftPanelContainer = $(`<div class="${pfx}pn-left-container ${pfx}${color}-container" data-index=${idx}>
            <a target="_blank" href="${help}">?</a><div class="close" data-index=${idx}>x</div>
        </div>`);

        let panelContent = '';
        switch (type) {
            case 'blocks':
                panelContent = blocks(editor, pfx, filters).get(0);
                break;
            case 'assets':
                panelContent = assets(editor, pfx).get(0);
                break;
            case 'twitch':
                panelContent = twitch(editor, pfx).get(0);
                break;
            case 'themes':
                panelContent = themes(editor, pfx).get(0);
                break;
            case 'settings':
                panelContent = settings(editor, pfx).get(0);
                break;
            default:
                panelContent = type || html;
                break;
        }

        appendToContent(leftPanelContainer.get(0), panelContent);
        leftPanelContainers.append($(`<div class="${pfx}${color}-curve curve" data-index=${idx}>
            <div class="curve-bottom"></div>
                <div class="curve-body">
            </div>
        </div>`));

        leftPanelContainers.append(leftPanelContainer);
    });

    const leftPanel = $(`<div id="${pfx}pn-left-panel"><div>`);
    leftPanel.append(leftPanelBtns);
    leftPanel.append(leftPanelContainers);

    const buttons = leftPanelBtns.find(`.${pfx}pn-left-btn`);
    const panels = leftPanelContainers.find(`.${pfx}pn-left-container`);
    const curves = leftPanelContainers.find('.curve');
    const closeBtns = leftPanelContainers.find('.close');

    closeBtns.on('click', function (e) {
        const idx = this.getAttribute('data-index');
        close(curves.get(idx));
        close(buttons.get(idx));
        close(panels.get(idx));
    })

    buttons.on('click', function (e) {
        const idx = this.getAttribute('data-index');
        const panel = panels.get(idx);
        const button = buttons.get(idx);
        const curve = curves.get(idx);
        const isOpen = button.dataset.active === "true";

        if (!isOpen) {
            closeAll(curves);
            closeAll(buttons);
            closeAll(panels);
            open(button);
            open(curve);
            open(panel);
        } else {
            close(curve);
            close(button);
            close(panel);
        }
    });

    return {
        leftPanel,
        panels,
        buttons,
        curves
    };
}